// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tree-detail_wrapper__B2xRZ","card":"tree-detail_card__3r0ri","card-content":"tree-detail_card-content__1Uw5P","cover-image":"tree-detail_cover-image__1W4MG"};